import { Component, Event, Host, h, EventEmitter, Listen, Method, State, Element } from '@stencil/core';

@Component({
  tag: 'me-backdrop',
  styleUrl: 'me-backdrop.scss',
  shadow: false,
})
export class MeBackdrop {

  @Element() host: HTMLMeBackdropElement;

  @State() isActive = false;

  private isAnimated = false;

  @Event() meBackdropOpen: EventEmitter<HTMLMeBackdropElement>;
  @Event() meBackdropClose: EventEmitter<HTMLMeBackdropElement>;

  @Listen('meMenuOpen', { target: 'window' })
  async handleMenuOpen() {
    await this.open();
  }

  @Listen('meMenuClose', { target: 'window' })
  async handleMenuClose() {
    await this.close();
  }

  @Listen('meModalOpen', { target: 'window' })
  async handleModalOpen() {
    await this.open();
  }

  @Listen('meModalClose', { target: 'window' })
  async handleModalClose() {
    await this.close();
  }

  componentDidLoad() {
    this.isAnimated = true;
  }

  render() {
    const classList = [
      'me-backdrop',
      this.isActive ? 'me-backdrop--active' : null,
      this.isAnimated ? 'me-backdrop--animated' : null,
    ].filter(c => !!c).join(' ');

    return (
      <Host class={classList} onClick={this.close.bind(this)} />
    );
  }

  @Method()
  async toggle() {
    this.isActive
      ? await this.close()
      : await this.open();
  }

  @Method()
  async open() {
    if (this.isActive) { return; }

    this.isActive = true;

    this.meBackdropOpen.emit(this.host);
  }

  @Method()
  async close() {
    if (!this.isActive) { return; }

    this.isActive = false;

    this.meBackdropClose.emit(this.host);
  }

}
